import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { FormikProps } from "formik";
import type { FormikPasswordRequirement } from "./PasswordDrawer";
import { Stack } from "components/layout/reusableLayouts";
import { TextField } from "@outpave/ds";

interface PasswordRequirementsProps {
  formik: FormikProps<FormikPasswordRequirement>;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = (props) => {
  const { formik } = props;
  const { t } = useTranslation();

  return (
    <Stack sx={{ flex: 1 }}>
      <Stack gap="var(--space-2)">
        <Typography variant="h3">{t("Password Requirements")}</Typography>
        <Typography variant="body1">
          {t("PasswordChangeDescription")}
        </Typography>
      </Stack>

      <TextField
        label={t("Password")}
        name="password"
        type="password"
        value={formik.values.password}
        fullWidth
        onChange={formik.handleChange}
        errorText={
          formik.errors["password"] && formik.touched["password"]
            ? formik.errors["password"]
            : undefined
        }
      />

      <TextField
        label={t("New Password")}
        name="newPassword"
        type="password"
        value={formik.values.newPassword}
        fullWidth
        onChange={formik.handleChange}
        errorText={
          formik.errors["newPassword"] && formik.touched["newPassword"]
            ? formik.errors["newPassword"]
            : undefined
        }
      />

      <TextField
        label={t("Re-type Password")}
        name="reTypePassword"
        type="password"
        value={formik.values.reTypePassword}
        fullWidth
        onChange={formik.handleChange}
        errorText={
          formik.errors["reTypePassword"] && formik.touched["reTypePassword"]
            ? formik.errors["reTypePassword"]
            : undefined
        }
      />
    </Stack>
  );
};

export default PasswordRequirements;
